import { render } from "./EditorDropDownMenu.vue?vue&type=template&id=44ba067f&scoped=true&ts=true"
import script from "./EditorDropDownMenu.vue?vue&type=script&lang=ts"
export * from "./EditorDropDownMenu.vue?vue&type=script&lang=ts"

import "./EditorDropDownMenu.vue?vue&type=style&index=0&id=44ba067f&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ba067f"]])

export default __exports__